import { createReducer, on } from '@ngrx/store';
import { UIState, initialUIState } from '../states/ui.state';
import * as UIActions from '../actions/ui.action';

export const uiReducer = createReducer(
    initialUIState,
    on(UIActions.changed, (state, payload) => ({
        ...state,
        ...payload
    }))
);